import {useTableTopOverlayBounds} from "@/tabletop/TableTopOverlayBounds.tsx";
import {useDungeon} from "@/encounter/dungeon/DungeonHooks.ts";
import {useEncounterViewPort} from "@/encounter/viewport/EncounterViewPortHooks.ts";
import {useVisibility} from "@/tabletop/visibility/useVisibility.ts";
import useEncounterLevelTransition from "./useEncounterLevelTransition.ts";
import {useGameMasterViewSettings} from "@/tabletop/gm/GameMasterViewSettingsHooks.ts";
import {useGameMasterMapInteractions} from "@/tabletop/gm/GameMasterMapInteractionHooks.ts";
import {useTransitionPreview} from "./useTransitionPreview.ts";
import {useLightLocks} from "./useLightLocks.ts";

export function useGameMasterMapModel() {
    const {showPlayerSight, showHostileSight, gmMaskOpacity, friendlyVisibility} = useGameMasterViewSettings();
    const {showAnnotations, placementMode, selection, annotations, closeMapPopovers,
        selectDoor, selectLight, placeLight, moveLight} = useGameMasterMapInteractions();
    const {mapTransform} = useEncounterViewPort();
    const {dungeon, dungeonSettings} = useDungeon();
    const activeLevel = dungeon.levels.find(level => level.id === dungeonSettings.levelId);
    const {arrivalPreview, transitionCenter, targetLevel, setHoveredTransitionId} = useTransitionPreview(activeLevel);
    const levelTransition = useEncounterLevelTransition(activeLevel);
    const hostileVisibility = useVisibility("hostile", showHostileSight);
    const {toggledLightLocks, toggleLightLock, canMoveLight} = useLightLocks(activeLevel);
    const {viewport: mapSize} = useTableTopOverlayBounds();

    return {
        showPlayerSight, showHostileSight, gmMaskOpacity, friendlyVisibility,
        showAnnotations, placementMode, selection, annotations, closeMapPopovers,
        selectDoor, selectLight, placeLight, moveLight, mapTransform, activeLevel,
        arrivalPreview, transitionCenter, targetLevel, setHoveredTransitionId, levelTransition,
        hostileVisibility, toggledLightLocks, toggleLightLock, canMoveLight, mapSize,
    };
}
export type GameMasterMapModel = ReturnType<typeof useGameMasterMapModel>;
